import { Dispatch, SetStateAction, useEffect, useRef, useState } from "react";
import {
  useOnlineCommandCheckMutation,
  useOnlineCommandMutation,
} from "redux/RTQ/IlenkradApi";
import { ToastDanger } from "utils/toast/Toast";

interface IPropsUseSendCommand {
  command: string;
  name: string;
  imei: string;
  setIsLoading: Dispatch<SetStateAction<boolean>>;
  handleValues: (arg0: string) => void;
  open: boolean;
  trigger: number;
  sendSms: (arg0: string) => void;
  online: boolean;
}

const SendCommand = ({
  command,
  name,
  imei,
  setIsLoading,
  handleValues,
  open,
  sendSms,
  trigger,
  online,
}: IPropsUseSendCommand) => {
  const [firstCommandSent, setFirstCommandSent] = useState(new Date());

  const [mutate, { data, isLoading, isError, isSuccess, error }] =
    useOnlineCommandMutation();
  const [
    mutateCheck,
    {
      data: dataCheck,
      isLoading: isLoadingCheck,
      isError: isErrorCheck,
      isSuccess: isSuccessCheck,
      error: errorCheck,
    },
  ] = useOnlineCommandCheckMutation();

  useEffect(() => {
    if (trigger > 0) {
      setIsLoading(true);
      checkForSendType();
    }
  }, [trigger]);

  const checkForSendType = () => {
    const body = {
      tracker_imei: imei,
      command: command,
      name: name,
    };
    console.log("sending command", body);
    let sendType = localStorage.getItem("commandSendType");

    if (!sendType) sendType = "0";
    if (sendType === "0" && !online) {
      ToastDanger("ردیاب به اینترنت متصل نمیباشد.");
      sendType = "2";
    }

    switch (sendType) {
      case "0":
      case "1":
        setFirstCommandSent(new Date());
        mutate(body);
        break;
      case "2":
        setIsLoading(false);
        sendSms(command);
        break;

      default:
        setFirstCommandSent(new Date());
        mutate(body);
        break;
    }
  };

  useEffect(() => {
    if (isSuccess && data) {
      const dataSuccess: any = data;
      setFirstCommandSent(new Date());
      mutateCheck(dataSuccess.online_command.id);
    } else if (isError) {
      setIsLoading(false);
      sendSms(command);
    }
  }, [isSuccess, isError]);

  useEffect(() => {
    if (isSuccessCheck) {
      const dataSuccess: any = dataCheck;
      const commandDataSuccess: any = data;

      if (dataSuccess.online_command) {
        if (dataSuccess.online_command.response) {
          setIsLoading(false);
          handleValues(dataSuccess.online_command.response);
        } else {
          if (
            new Date().getTime() - firstCommandSent.getTime() <= 15000 &&
            open
          ) {
            setTimeout(() => {
              mutateCheck(commandDataSuccess.online_command.id);
            }, 300);
          } else {
            setIsLoading(false);
            sendSms(command);
            ToastDanger("پاسخی از ردیاب دریافت نشد.");
          }
        }
      }
    } else if (isErrorCheck) {
      setIsLoading(false);
      sendSms(command);
    }
  }, [isSuccessCheck, isErrorCheck]);

  return null;
};

export default SendCommand;
